var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"account-settings mt-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"4"}},[_c('b-card',{attrs:{"header":"SIP settings","header-tag":"header"}},[_c('SipSettings')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }